<div class="alert alert-danger" *ngIf="error">
  Error: {{ error }}
  <br>
  <button (click)="resetTable()" class="btn btn-primary">Reset Table</button>
</div>

<div id="table-container-{{ randomUuid }}" [ngClass]="showBorder ? 'card' : ''" class="" *ngIf="!error">
  <ng-container
    *ngIf="tableDisplayConfig.tableConfig.filter_type === TableFilterDisplayTypeEnum.SINGLE_COLUMN_DROPDOWN_FILTER">
    <div class="card-body h-100 d-grid grid-template-rows-auto-1fr-auto">
      <div *ngIf="showTopRow" class="row">
        <div class="col-12">
          <div class="table-filter-grid">
            <div class="main">
              <div class="row">
                <div class="col-12 col-md-8">
                  <app-table-filter
                    *ngIf="(tableDisplayConfig.tableConfig.columns | objectArrayContainsValue: 'quick_filter': true)"
                    id="quick-table-filter"
                    [quickFilterOnly]="true"
                    [quickFilterSpacing]="false"
                    [tableDisplayConfig]="tableDisplayConfig"
                    [globalFilter]="globalFilter"
                    [compactView]="false"
                    [withoutLabel]="true"
                    [smallInput]="false"
                    [inlineInput]="false"
                    [rowSpacing]="false"
                    (tableDisplayConfigChange)="filtersChanged($event)"
                    (settingsClicked)="openSorter.next()"
                  ></app-table-filter>
                </div>
                <div class="col-12 col-md-4">
                  <app-table-favorite-selector
                    [formControl]="favoriteFormControl"
                    [showFavorites]="showFavorites"
                    [tableDisplayConfig]="tableDisplayConfig"
                    [reloadFavorites]="reloadFavorites"
                    (favoriteDeleted)="selectedFavorite(null)"
                  ></app-table-favorite-selector>
                </div>
              </div>
            </div>
            <div class="button">
              <div class="py-2">
                <div class="btn-group align-self-center justify-self-end ps-3">
                  <button type="button" class="btn " [class.btn-outline-secondary]="!showFilters"
                          [class.btn-secondary]="showFilters" (click)="toggleFilter()">
                    <i class="fa-solid fa-search-plus"></i>
                  </button>
                  <button type="button" class="btn btn-outline-secondary" (click)="openSorter.next()">
                    <i class="fa-solid fa-cogs"></i>
                  </button>
                </div>
              </div>

            </div>
          </div>
        </div>

        <div *ngIf="showFilters" class="col-12">
          <app-dropdown-table-filter
            id="expandable-table-filter"
            [tableDisplayConfig]="tableDisplayConfig"
            [globalFilter]="globalFilter"
            (tableDisplayConfigChange)="filtersChanged($event)"
            (settingsClicked)="openSorter.next()"
          ></app-dropdown-table-filter>
        </div>

        <div *ngIf="showFilters" class="col-12">
          <div class="table-filter-grid py-2">
            <div class="main">
              <div class="row">
                <div class="col-4">
                  <button type="button" class="btn btn-outline-secondary" (click)="resetTable()">
                    {{ 'table.reset_filter' | translate }}
                  </button>
                </div>
                <div class="col-4"></div>
                <div class="col-4">
                  <form *ngIf="tableDisplayConfig!.tableConfig.id" class="w-100" [formGroup]="favoriteForm">
                    <input type="text" [formControl]="favoriteForm.controls.title" class="form-control"
                           aria-label="Text input with segmented dropdown button">
                  </form>
                </div>
              </div>
            </div>
            <div class="button">
              <button type="button" (click)="saveFavorite()" [disabled]="favoriteForm.controls.title.invalid"
                      class="btn btn-outline-secondary float-end" title="{{'table_filter.save_favorite' | translate}}">
                <i class="fa-solid fa-floppy-disk"></i>
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="row overflow-hidden h-100" *ngIf="!data">
        <div class="mx-auto my-auto text-center w-100">
          <i class="fa fa-circle-notch  fa-spin fa-2x  text-secondary"></i>
        </div>

      </div>

      <!-- this div should grow to max height of .card -->
      <div class="row overflow-hidden" *ngIf="data && tableDisplayConfig?.tableConfig">
        <app-table-data
          class="h-100"
          #tableData
          [data]="data"
          [isLoading]="isLoading"
          [routerLinkPrefix]="routerLinkPrefix"
          [routerLinkSuffix]="routerLinkSuffix"
          [routerLinkValue]="routerLinkValue"
          [showEditLink]="showEditLink"
          [routerErrorText]="routerErrorText"
          (pageChanged)="goToPage($event)"
          (sorted)="sort($event)"
          [functionList]="functionList"
          [tableDisplayConfig]="tableDisplayConfig"
          [additionalButton]="additionalButton"
          [additionalButtonWidth]="additionalButtonWidth"
          [additionalButtonHeaderText]="additionalButtonHeaderText"
          [isSubtable]="isSubtable"
          [cellTemplate]="cellTemplate"
        ></app-table-data>
      </div>

      <!-- this div should always be at the bottom of the card -->
      <div class="row" *ngIf="data?.meta">
        <div class="col">
          <app-table-pagination
            [data]="data"
            *ngIf="data"
            (goToPage)="goToPage($event)">
          </app-table-pagination>
        </div>

        <div class="ms-auto col d-flex justify-content-end align-self-center text-muted small">
          {{ data?.meta?.total | number }} {{ 'table.total' | translate }}
        </div>

      </div>

    </div>
  </ng-container>
</div>

<app-table-column-sorter
  *ngIf="tableDisplayConfig?.tableConfig"
  [tableDisplayConfig]="tableDisplayConfig"
  (tableDisplayConfigChange)="columnsChanged($event)"
  (hiddenColumnsChanged)="hiddenColumnsChanged($event)"
  [openListener]="openSorter"
  (resetTable)="resetTable()"
></app-table-column-sorter>
